<template>
  <div
    v-if="event"
    :class="
      isMobile
        ? 'vuecal__event-title'
        : 'flex flex--top cal-day-info cursor-p relative'
    "
  >
    <div
      v-if="event.status"
      class="label-status"
      :class="getSurgStatusClass(event.status)"
    >
      {{ event.status }}
    </div>
    <h2>{{ getTime(event.end) }} - {{ getTime(event.start) }}</h2>
    <div
      class="cal-day-info-list is--fit flex flex--start"
      @click="$router.push('/surg-info/' + event.id)"
    >
      <div class="line-clamp">
        <span v-if="$route.name == 'surg-app-list'"
          ><span class="bold">ניתוח</span> |</span
        >
        <span v-if="event.orders && event.orders.length">
          <div
            v-for="(side, i) in event.orders"
            :key="side.id"
            style="display: inline-block;"
          >
            {{ side.tafnit_code + " > " + side.tafnit_name }}
            {{ i == event.orders.length - 1 ? "" : "," }}
          </div>
        </span>
        <span v-else-if="event.surgeryName">{{ event.surgeryName }}</span>
        | {{ event.patient_name }} |
        {{ event.room.value.name }}
        <span v-if="event.insurance_fee">{{
          " | סך השתתפות עצמית: ₪" + event.insurance_fee
        }}</span>
        <span v-if="event.insurance_status_heb">{{
          " | סטטוס התחייבות: " + event.insurance_status_heb
        }}</span>
        <span v-if="event.insurance_code">{{
          " | מספר התחייבות: " + event.insurance_code
        }}</span>
        <span v-if="event.patient_age">{{
          " | גיל המטופל: " + event.patient_age
        }}</span>
        <span v-if="event.gender">{{ " | מגדר: " + event.gender }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SurgListEvent",
  props: {
    event: {
      required: true
    },
    isMobile: { default: false }
  },
  methods: {
    getTime(date) {
      return this.$moment(date).format("LT");
    },
    getSurgStatusClass(type) {
      return this.$store.getters["getSurgStatusClass"](type);
    }
  }
};
</script>
